/**
 * Messages module translations - Buttons section
 */

const buttons = {
  addMessage: "Add message",
  delete: "Delete",
  markAsReceived: "Mark as received",
  mark: "Mark",
  unmark: "Unmark",
  downloadAttached: "Download attached files",
  downloadDocument: "Download document",
  removeFromMarkers: "Remove from markers",
  addToMarkers: "Add to markers",
  view: "View",
  changeStatus: "Change Status",
  submit: "Submit",
  cancel: "Cancel",
  back: "Back",
  addFile: "Add file",
  upload: "Upload",
  next: "Next",
  close: "Close",
  confirm: "Confirm",
  downloadTemplate: "Download template",
};

export default buttons;
